// src/App.tsx
import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Scanner from './components/Scanner';
import HowItWorks from './components/HowItWorks';
import Performance from './components/Performance';
import Footer from './components/Footer';
import { api } from './services/api';
import './App.css';

function App() {
  const [apiStatus, setApiStatus] = useState<'online' | 'offline' | 'checking'>('checking');

  useEffect(() => {
    checkApiStatus();
  }, []);

  const checkApiStatus = async () => {
    try {
      await api.health();
      setApiStatus('online');
    } catch (error) {
      setApiStatus('offline');
    }
  };

  return (
    <div className="app">
      {apiStatus === 'offline' && (
        <div className="api-offline-banner">
          ⚠️ API is currently offline. Please start the backend server to use the scanner.
        </div>
      )}
      <Navbar />
      <Hero />
      <Scanner apiStatus={apiStatus} />
      <HowItWorks />
      <Performance />
      <Footer />
    </div>
  );
}

export default App;